import styled from 'styled-components';

import { mqSmallMax } from 'styled/tools/media-queries';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: ${(props) => props.theme.flexDirection || 'row'};
  ${(props) =>
    props.theme.background ? `background: ${props.theme.background}` : null};
  justify-content: ${(props) => props.theme.justify || 'flex-start'};
  align-items: ${(props) => props.theme.align || 'flex-start'};
  padding: ${(props) => props.theme.padding || '.25rem 0rem'};
  margin: ${(props) => props.theme.margin || '0'};
  gap: ${(props) => props.theme.gap || '.75rem'};
  input {
    min-width: 12px;
    min-height: 12px;
  }
  ${(props) => (props.theme.width ? `width: ${props.theme.width}` : null)};
  ${(props) => (props.theme.height ? `height: ${props.theme.height}` : null)};
  ${(props) =>
    props.theme.borderTop ? `border-top: ${props.theme.borderTop}` : null};

  @media ${mqSmallMax} {
    ${(props) =>
      props.theme.smallMargin ? `margin: ${props.theme.smallMargin}` : null};
  }
`;
